import { safeLocalStorage } from './storageWrapper';

/**
 * Helper to resolve media URLs from either static paths or custom uploaded images in localStorage.
 */
export function resolveMediaUrl(defaultUrl: string, key?: string): string {
  // If there's no key, immediately return the default URL and skip localStorage
  if (!key || key === 'undefined') {
    return defaultUrl;
  }

  if (typeof window !== 'undefined') {
    try {
      let customValue = safeLocalStorage.getItem(`cozzydine_media_${key}`);

      // Dynamic fallback mapping to keep room cards and gallery slides in sync
      if (!customValue) {
        if (key === 'gallery_purple_room') {
          customValue = safeLocalStorage.getItem('cozzydine_media_double-room');
        } else if (key === 'double-room') {
          customValue = safeLocalStorage.getItem('cozzydine_media_gallery_purple_room');
        } else if (key === 'gallery_lounge') {
          customValue = safeLocalStorage.getItem('cozzydine_media_about-reception');
        } else if (key === 'about-reception') {
          customValue = safeLocalStorage.getItem('cozzydine_media_gallery_lounge');
        } else if (key === 'gallery_dorms') {
          customValue = safeLocalStorage.getItem('cozzydine_media_eight-bed-dorm') || safeLocalStorage.getItem('cozzydine_media_six-bed-dorm');
        } else if (key === 'gallery_kitchenette') {
          customValue = safeLocalStorage.getItem('cozzydine_media_eight-bed-dorm') || safeLocalStorage.getItem('cozzydine_media_six-bed-dorm');
        }
      }

      if (customValue && customValue.startsWith('data:image')) {
        return customValue;
      }
    } catch (e) {
      console.warn('Could not read custom media from safeLocalStorage:', e);
    }
  }
  return defaultUrl;
}
